"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertifierPicker = exports.getCertifierShape = exports.CertifierTitles = void 0;
var react_1 = __importStar(require("react"));
var yup = __importStar(require("yup"));
var labels_1 = require("../labels");
var controls_1 = require("../controls");
var inputs_1 = require("../inputs");
var validation_1 = require("../validation");
var CertifierTitles;
(function (CertifierTitles) {
    CertifierTitles["Secretary"] = "Secretary";
    CertifierTitles["PublicOfficer"] = "PublicOfficer";
    CertifierTitles["Other"] = "Other";
})(CertifierTitles || (exports.CertifierTitles = CertifierTitles = {}));
var getCertifierShape = function (deps, isRequired) { return ({
    certifierAuthority: yup
        .boolean()
        .when(__spreadArray([], deps, true), {
        is: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('Do you have authority to sign official documents on behalf of the company'),
    certifierTitle: yup
        .mixed()
        .oneOf(Object.values(CertifierTitles))
        .when(__spreadArray(['certifierAuthority'], deps, true), {
        is: function (certifierAuthority) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return certifierAuthority !== undefined && isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('Role'),
    certifierOtherTitle: yup
        .string()
        .when(__spreadArray(['certifierTitle'], deps, true), {
        is: function (certifierTitle) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return certifierTitle === CertifierTitles.Other && isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('Declaration certifier other role description'),
    certifierFirstName: yup
        .string()
        .when(__spreadArray(['certifierAuthority'], deps, true), {
        is: function (certifierAuthority) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return certifierAuthority === false && isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('First name'),
    certifierLastName: yup
        .string()
        .when(__spreadArray(['certifierAuthority'], deps, true), {
        is: function (certifierAuthority) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return certifierAuthority === false && isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('Last name'),
    certifierEmail: yup
        .string()
        .when(__spreadArray(['certifierAuthority'], deps, true), {
        is: function (certifierAuthority) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return certifierAuthority === false && isRequired.apply(void 0, args);
        },
        then: function (schema) { return schema.required(); },
    })
        .label('Email'),
}); };
exports.getCertifierShape = getCertifierShape;
var CertifierPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange, errors = _a.errors, readOnly = _a.readOnly, className = _a.className;
    var setCertifierAuthority = function (certifierAuthority) {
        if (readOnly)
            return;
        if (value.certifierAuthority == certifierAuthority) {
            return;
        }
        if (certifierAuthority) {
            onChange({
                certifierTitle: undefined,
                certifierOtherTitle: undefined,
                certifierFirstName: '',
                certifierLastName: '',
                certifierEmail: '',
                certifierAuthority: certifierAuthority,
            }, ['certifierAuthority']);
        }
        else {
            onChange({
                certifierTitle: undefined,
                certifierOtherTitle: undefined,
                certifierAuthority: certifierAuthority,
            }, ['certifierAuthority']);
        }
    };
    (0, react_1.useEffect)(function () {
        if (readOnly)
            return;
        if (value.certifierTitle !== CertifierTitles.Other) {
            onChange({ certifierOtherTitle: undefined }, validation_1.ValidationHint.NoValidation);
        }
    }, [value.certifierTitle]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col col-12" },
                react_1.default.createElement(labels_1.Label, { id: "authorityToCertify", label: "Do you have authority to sign official documents on behalf of the company (e.g., you are the secretary or public officer)?", error: errors === null || errors === void 0 ? void 0 : errors.certifierAuthority, required: true },
                    react_1.default.createElement(controls_1.RadioList, { disabled: readOnly, id: "authorityToCertify", value: value.certifierAuthority, options: [
                            {
                                label: 'Yes',
                                value: true,
                            },
                            {
                                label: 'No, but I have appropriate authorisation to submit the form',
                                value: false,
                            },
                        ], onChange: setCertifierAuthority })))),
        value.certifierAuthority === true && (react_1.default.createElement("div", { className: "row mt-4" },
            react_1.default.createElement("div", { className: "col col-6" },
                react_1.default.createElement(labels_1.Label, { id: "certifierTitle", label: "Please select which best describes your role", error: errors === null || errors === void 0 ? void 0 : errors.certifierTitle, required: true },
                    react_1.default.createElement(controls_1.RadioList, { disabled: readOnly, id: "certifierTitle", value: value.certifierTitle, options: [
                            {
                                label: 'Secretary',
                                value: CertifierTitles.Secretary,
                            },
                            {
                                label: 'Public Officer',
                                value: CertifierTitles.PublicOfficer,
                            },
                            {
                                label: 'Other',
                                value: CertifierTitles.Other,
                            },
                        ], onChange: function (certifierTitle) { return onChange({ certifierTitle: certifierTitle }); } }))),
            value.certifierTitle === CertifierTitles.Other && (react_1.default.createElement("div", { className: "col col-6" },
                react_1.default.createElement(labels_1.Label, { id: "certifierOtherTitle", label: "Other role description", error: errors === null || errors === void 0 ? void 0 : errors.certifierOtherTitle, required: value.certifierTitle === CertifierTitles.Other },
                    react_1.default.createElement(inputs_1.TextInput, { disabled: readOnly, value: value.certifierOtherTitle || '', onChange: function (certifierOtherTitle) { return onChange({ certifierOtherTitle: certifierOtherTitle }); }, size: "block", maxLength: 400 })))))),
        value.certifierAuthority === false && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "row mt-4" },
                react_1.default.createElement("div", { className: "col col-12 mb-2" },
                    react_1.default.createElement("h6", null, "Details of the person with authority to sign official documents:")),
                react_1.default.createElement("div", { className: "col col-6" },
                    react_1.default.createElement(labels_1.Label, { id: "certifierFirstName", label: "First name", className: "mt-2", error: errors === null || errors === void 0 ? void 0 : errors.certifierFirstName, required: value.certifierAuthority === false },
                        react_1.default.createElement(inputs_1.TextInput, { disabled: readOnly, value: value.certifierFirstName || '', onChange: function (certifierFirstName) {
                                return onChange({
                                    certifierFirstName: certifierFirstName,
                                });
                            }, size: "block", maxLength: 200 })),
                    react_1.default.createElement(labels_1.Label, { id: "certifierLastName", label: "Last name", className: "mt-2", error: errors === null || errors === void 0 ? void 0 : errors.certifierLastName, required: value.certifierAuthority === false },
                        react_1.default.createElement(inputs_1.TextInput, { disabled: readOnly, value: value.certifierLastName || '', onChange: function (certifierLastName) { return onChange({ certifierLastName: certifierLastName }); }, size: "block", maxLength: 200 }))),
                react_1.default.createElement("div", { className: "col col-6" },
                    react_1.default.createElement(labels_1.Label, { id: "certifierEmail", label: "Email", className: "mt-2", error: errors === null || errors === void 0 ? void 0 : errors.certifierEmail, required: value.certifierAuthority === false },
                        react_1.default.createElement(inputs_1.TextInput, { type: "email", disabled: readOnly, value: value.certifierEmail || '', onChange: function (certifierEmail) { return onChange({ certifierEmail: certifierEmail }); }, size: "block", maxLength: 400 })),
                    react_1.default.createElement(labels_1.Label, { id: "certifierTitle", label: "Person's role", className: "mt-2", error: errors === null || errors === void 0 ? void 0 : errors.certifierTitle, required: value.certifierAuthority === false },
                        react_1.default.createElement(controls_1.RadioList, { disabled: readOnly, id: "rdl-declarationCertifierTitle", value: value.certifierTitle, options: [
                                {
                                    label: 'Secretary',
                                    value: CertifierTitles.Secretary,
                                },
                                {
                                    label: 'Public Officer',
                                    value: CertifierTitles.PublicOfficer,
                                },
                                {
                                    label: 'Other',
                                    value: CertifierTitles.Other,
                                },
                            ], onChange: function (certifierTitle) {
                                onChange({ certifierTitle: certifierTitle });
                            } })),
                    value.certifierTitle === CertifierTitles.Other && (react_1.default.createElement(labels_1.Label, { id: "certifierOtherTitle2", label: "Other role description", className: "mt-2", error: errors === null || errors === void 0 ? void 0 : errors.certifierOtherTitle, required: value.certifierTitle === CertifierTitles.Other },
                        react_1.default.createElement(inputs_1.TextInput, { disabled: readOnly, value: value.certifierOtherTitle || '', onChange: function (certifierOtherTitle) { return onChange({ certifierOtherTitle: certifierOtherTitle }); }, size: "block", maxLength: 400 })))))))));
};
exports.CertifierPicker = CertifierPicker;
//# sourceMappingURL=CertifierPicker.js.map